import { Icon, IconProps } from '@iconify/react/dist/iconify.js';
import { Box, Chip, Paper, PaperProps, Skeleton, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import IconText from './IconText';
import { getLabelColor, getLabelStatus } from '@/utils/helpers';
import { Patient } from '@/types/database';

export interface Props extends PaperProps {
  icon: IconProps['icon'];
  loading?: boolean;
  name: string;
  phone?: string;
  email?: string;
  description?: string;
  labels: Patient['status'][];
}

const TabItem: FC<Props> = ({ icon, name, phone, email, description, labels, loading, onClick, ...props }) => {
  if (loading) return <Skeleton color="textSecondary" height="60px" variant="rectangular" />;

  return (
    <Paper variant="outlined" onClick={onClick} sx={{ ...styles, ...props.sx } as PaperProps['sx']}>
      <Icon height={36} icon={icon} />
      <Box flexGrow={1}>
        <Box display="flex" alignItems="center">
          {name}&nbsp;
          {labels?.map(
            (label, i) =>
              getLabelStatus(label) && (
                <Chip
                  color={getLabelColor(label)}
                  size="small"
                  key={i}
                  label={
                    <Typography component="span" fontSize={10}>
                      {getLabelStatus(label)}
                    </Typography>
                  }
                  variant="outlined"
                />
              )
          )}
        </Box>
        {description && (
          <Typography color="textSecondary" variant="body2">
            {description}
          </Typography>
        )}
        <Typography textOverflow="ellipsis" color="textSecondary" fontSize={12} display="flex" gap={1}>
          {phone && (
            <IconText color="inherit" fontSize="inherit" icon="material-symbols:call">
              {phone}
            </IconText>
          )}
          {email && (
            <IconText color="inherit" fontSize="inherit" icon="ic:baseline-email">
              {email}
            </IconText>
          )}
        </Typography>
      </Box>
      <Icon color="gray" icon="picon:right" />
    </Paper>
  );
};

export default TabItem;

const styles: PaperProps['sx'] = {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  p: 1,
  transition: '0.2s ease-in-out',
  gap: 1,

  '&:hover': {
    backgroundColor: 'rgba(0, 119, 182, 0.04)',
    transform: 'translateY(-2px)',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 4px 8px;',
  },
};
